import { Directive, HostBinding, Input } from '@angular/core';

export type SlButtonType = 'primary' | 'secondary' | 'tertiary' | 'link' | 'icon';

@Directive({
    selector: '[buttonType]',
    standalone: true
})
export class SlButtonTypeDirective {
    @Input() public buttonType: SlButtonType;

    @HostBinding('class')
    get classes(): Record<string, boolean> {
        return {
            'sl-button': true,
            'sl-button-primary': this.buttonType === 'primary',
            'sl-button-secondary': this.buttonType === 'secondary',
            'sl-button-tertiary': this.buttonType === 'tertiary',
            'sl-button-link': this.buttonType === 'link',
            'sl-button-icon': this.buttonType === 'icon'
        };
    }
}
